import { getDarkenColor, getLightenColor, hexToRgbA } from "./"
const headerHeightSmall = 78
export default (type, colors) => {
  const styles = {
    default: {
      global: {
        customCSS: `
          .logo__image {
            width: auto;
            max-height: 40px;
            margin: 0 auto;
          }
        `
      }
    },
    type1: {
      global: {
        customCSS: `
          body {
            background: ${colors.light};
            color: ${colors.dark};
            font-family: 'Helvetica-Neue-LT-Std';
          }

          body .mapboxgl-ctrl-group .mapboxgl-ctrl-icon {
            background-color: ${colors.secondary};
            box-shadow: 1px 1px 0 0 ${colors.secondary};
          }

          body .mapboxgl-ctrl-group .mapboxgl-ctrl-icon:hover, 
          body .mapboxgl-ctrl-group .mapboxgl-ctrl-icon:focus {
            background-color: ${getDarkenColor(colors.secondary, 0.05)};
          }

          .button {
            font-size: 14px;
            box-shadow: none;
            text-transform: uppercase;
            background-color: ${colors.secondary};
          }

          .button:hover,
          .button:focus {
            box-shadow: none;
            background-color: ${getDarkenColor(colors.secondary, 0.05)};
          }

          a {
            color: ${colors.primary};
          }

          a:hover, 
          a:active,  
          a:focus {
            color: ${getDarkenColor(colors.primary, 0.07)};
          }

          h1 a, 
          h2 a, 
          h3 a, 
          h4 a, 
          h5 a, 
          h6 a, 
          .link--nostyle {
            color: ${colors.dark};
          }

          .link--nostyle:hover, 
          .link--nostyle:active, 
          .link--nostyle:focus, 
          h1 a:hover, 
          h2 a:hover, 
          h3 a:hover, 
          h4 a:hover, 
          h5 a:hover, 
          h6 a:hover, 
          h1 a:active,
          h2 a:active, 
          h3 a:active, 
          h4 a:active, 
          h5 a:active, 
          h6 a:active, 
          h1 a:focus, 
          h2 a:focus, 
          h3 a:focus, 
          h4 a:focus, 
          h5 a:focus, 
          h6 a:focus {
            color: ${colors.dark};
            background-image: none;
          }

          select,
          label {
            color: ${getDarkenColor(colors.primary, 0.17)};
          }

          select:hover,
          select:focus {
            box-shadow: 1px 1px 0 0 ${getDarkenColor(
              getLightenColor(colors.secondary, 0.5),
              0.05
            )};
            color: ${getDarkenColor(colors.primary, 0.07)};
          }

          [type=text], 
          [type=password], 
          [type=date], 
          [type=datetime], 
          [type=datetime-local], 
          [type=month], 
          [type=week], 
          [type=email], 
          [type=number], 
          [type=search], 
          [type=tel], 
          [type=time], 
          [type=url], 
          [type=color], 
          textarea {
            color: #686868;
            box-shadow: inset 0px 2px 9px ${hexToRgbA(
              colors.dark,
              0.1
            )}!important;
          }

          [type=text]:disabled, 
          [type=password]:disabled, 
          [type=date]:disabled, 
          [type=datetime]:disabled, 
          [type=datetime-local]:disabled, 
          [type=month]:disabled, 
          [type=week]:disabled, 
          [type=email]:disabled, 
          [type=number]:disabled, 
          [type=search]:disabled, 
          [type=tel]:disabled, 
          [type=time]:disabled, 
          [type=url]:disabled, 
          [type=color]:disabled,
          textarea:disabled {
            background: ${getLightenColor(colors.primary, 2.3)};
          }

          .links--underline a:not(.button) {
            background-image: linear-gradient(rgba(0,0,0,0) 50%, ${getLightenColor(
              colors.primary,
              2
            )} 50%);
          }

          .links--underline a:not(.button):hover,
          .links--underline a:not(.button):active,
          .links--underline a:not(.button):focus {
            background-image: linear-gradient(rgba(0,0,0,0) 50%, ${getLightenColor(
              colors.primary,
              0.15
            )} 50%);
          }

          .links--dark a {
            color: ${colors.secondary_dark};
          }

          .links--dark a:hover, 
          .links--dark a:active, 
          .links--dark a:focus {
            color: ${getDarkenColor(colors.secondary_dark, 0.2)};
          }

          .logo__image {
            width: auto;
            max-height: 40px;
          }

          .link-list li {
            border-color: ${getLightenColor(colors.secondary, 0.5)};
          }

          .link-list li a {
            color: ${colors.primary};
          }

          .link-list li a:hover,
          .link-list li a:active,
          .link-list li a:focus {
            color: ${getDarkenColor(colors.primary, 0.07)};
          }

          .link--alert {
            color: ${colors.info};
          }

          .link--alert:hover, 
          .link--alert:active, 
          .link--alert:focus{
            color: ${getDarkenColor(colors.info, 0.1)};
          }

          p a:not(.button), 
          .typography a:not(.button) {
            background-image: linear-gradient(rgba(0,0,0,0) 50%, ${getLightenColor(
              colors.primary,
              2
            )} 50%);
          }
          
          p a:hover:not(.button), 
          p a:focus:not(.button), 
          p a:active:not(.button), 
          .typography a:hover:not(.button), 
          .typography a:active:not(.button), 
          .typography a:focus:not(.button) {
            background-image: linear-gradient(rgba(0,0,0,0) 50%, ${getLightenColor(
              colors.primary,
              0.15
            )} 50%);
          }

          .typography ul li:before,
          ul .list--default li:before,
          .subdued-more {
            color: ${colors.offgray_mid};
          }

          blockquote p {
            color: ${colors.tertiary};
          }

          blockquote:before {
            color: ${colors.offgray_mid};
          }
          
          .badge__content {
            height: auto;
          }

          .mbm{
            margin-bottom:0px !important;
          }

          .load-more {
            color: ${colors.secondary_dark};
          }

          .load-more:before {
            background: ${getLightenColor(colors.secondary, 0.5)};
          } 

          .load-more:hover, 
          .load-more:active,   
          .load-more:focus {
            color: ${getDarkenColor(colors.secondary_dark, 0.2)};
          }

          .load-more__inner {
            background: ${colors.light};
          }

          .panel {
            background: ${getLightenColor(colors.primary, 2)};
          }

          [data-whatinput=keyboard] :focus,
          input[type=range]:focus,
          input[type=range]:focus::-webkit-slider-runnable-track,
          input[type=range]:-moz-focusring {
            outline: ${colors.quaternary} auto 1px;
          }

          .thumbnail-grid--slider-strip a {
            border-color: ${colors.quaternary};
          }

          .thumbnail-grid--slider-strip .thumbnail-grid__item-pill {
            background: ${colors.quaternary};
          }

          .thumbnail-grid__item a {
            padding: 0;
            border: none;
          }

          .panel--warning {
            background: ${colors.info};
            color: ${colors.light};
          }
          
          label.required:after,
          .color-alert{
            color: ${colors.info};
          }

          .popover-title {
            background-color: ${colors.secondary_dark};
          }
 
          .slick-arrow {
            color: ${colors.primary};
          }
 
          .slick-arrow {
            background-color: ${getLightenColor(colors.secondary, 0.5)};
            box-shadow: 1px 1px 0 0 ${colors.offgray_mid};
          }
          
          .slick-arrow:hover,
          .slick-arrow:focus {
            color: ${colors.primary};
            background-color: ${getDarkenColor(
              getLightenColor(colors.secondary, 0.5),
              0.05
            )};
            box-shadow: 1px 1px 0 0 ${getDarkenColor(colors.offgray_mid, 0.05)};
          }

          dt,
          .subdued,
          .c-image-upload__preview-unnavailable,
          .c-comment__meta small {
            color: ${getDarkenColor(colors.light, 0.4)};
          }
        
          a.more-info {
            color: ${colors.primary};
          }

          @media screen and (min-width: 48em) {
            body.state-filters-expanded.view--no-chrome {
              padding-top: ${headerHeightSmall}px;
            }
          }
        `
      }
    }
  }

  return styles[type]
}



// WEBPACK FOOTER //
// ./webapp/styles/dynamicStyles/globalStyles.js